import { getData } from "../API/GlobalApi";


export const handlePaginate = async ({
  selectedPage,
  url,
  filterQueryString = '',
  setResults,
  setTotalCount,
  triggerTableLoading,
  stopTableLoading,
  setFilterQueryString, setLoading, 
}) => {

  const pageNumber = selectedPage + 1;
  const queryParams = new URLSearchParams(filterQueryString);
  queryParams.set('page', pageNumber);

  const finalUrl = `${url}?${queryParams.toString()}`;
 
  try {
     // Start loader/overlay if provided
  if (triggerTableLoading) triggerTableLoading();
       if (setLoading) setLoading(true); // start loader
    const response = await getData(finalUrl);
 
    setResults?.(
      Array.isArray(response?.results)
        ? response.results
        : Array.isArray(response?.results?.data)
          ? response.results.data
          : []
    );

    setTotalCount?.(response?.count || 0);
    setFilterQueryString?.(queryParams.toString());
  } catch (err) {

    setResults?.([]);
    setTotalCount?.(0);
  } finally {
     if (stopTableLoading) stopTableLoading();
    if (setLoading) setLoading(false); // stop loader
  }
};
